import { Box, BoxProps, Chip, Typography } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import AvatarWithLoader from 'components/avatar-with-loader'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { NivosNews } from 'types/nivos-news'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
  }
}

interface OwnProps {
  news: NivosNews
  containerProps?: BoxProps
}

type AppProps = StateProps & DispatchProps & OwnProps

const NewsCardFC: React.FC<any> = (props: AppProps) => {
  const { news, containerProps } = props
  return (
    <Box
      display={'flex'}
      border={2}
      borderRadius={4}
      borderColor={'#d4d2d2'}
      padding={1}
      margin={2}
      width={550}
      minWidth={550}
      height={185}
      {...containerProps}
    >
      <AvatarWithLoader
        src={news.images.length > 0 ? news.images[0].url : ''}
        avatarProps={{
          sx: {
            width: 140,
            height: 'auto',
            maxHeight: 140,
            borderRadius: 4
          }
        }}
        containerProps={{
          minWidth: 130,
          margin: 2
        }}
      />
      <Box display={'flex'} flexDirection={'column'} padding={1}>
        <Typography variant={'h5'}>{news.title}</Typography>
        <Typography variant={'body1'} gutterBottom>
          {news.date.toDateString()}
        </Typography>
        <Typography variant={'body1'} overflow={'hidden'} marginY={1}>
          {news.message}
        </Typography>
        <Box display={'flex'} padding={1}>
          <Chip
            variant={'filled'}
            color={news.important ? 'warning' : 'primary'}
            label={news.important ? 'Important' : 'Not Important'}
          />
          <Typography marginLeft={'auto'}>More..</Typography>
        </Box>
      </Box>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations
})

const NewsCard = connect(
  mapStateToProps,
  mapDispatchToProps
)(NewsCardFC) as React.FC<OwnProps>

export default NewsCard
